import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import TooltipIcon from "../../../../assets/svg/tooltip.svg";
import InfoIcon from "../../../../assets/svg/info.svg";
import sanitizeHTML from "@/utils/sanitizeHtml";
import "./styles.scss";

interface TooltipProps {
  content: string;
  position?: "top" | "right" | "bottom" | "left";
  openOnClick: boolean;
  dataFor: string;
  icon?: "tooltip" | "info";
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  openOnClick = false,
  dataFor,
  icon = "tooltip",
}) => {
  const position = "top";
  return (
    <>
      <span
        data-tooltip-id={dataFor}
        className="tooltip"
        data-testid="tooltip"
        data-tooltip-variant="light">
        {icon === "tooltip" && (
          <TooltipIcon
            viewBox="0 0 24 24"
            className="tooltip__svg"
          />
        )}
        {icon === "info" && (
          <InfoIcon
            viewBox="0 0 16 16"
            className="tooltip__svg"
          />
        )}
      </span>
      <ReactTooltip
        id={dataFor}
        place={position}
        className="tooltip__message"
        openOnClick={openOnClick}>
        <span
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(content),
          }}
        />
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
